<template>
  <main class="prizes">
    <img class="img_glow_left" src="/static/images/home/glow.png">
    <section>
      <h1>{{ getTranslations.home_leaderboard_your_rank }}</h1>
    </section>

    <section class="tabs">
      <!-- Tab Buttons -->
      <div class="tab-buttons">
        <button
          class="tab-button"
          :class="{ active: currentTab === 'rank-games' }"
          @click="changeTab('rank-games')"
        >
          {{ getTranslations.home_leaderboard_your_rank_games }}
        </button>

        <button
          class="tab-button"
          :class="{ active: currentTab === 'rank-prizes' }"
          @click="changeTab('rank-prizes')"
        >
          {{ getTranslations.home_leaderboard_your_rank_prizes }}
        </button>
      </div>

      <!-- Tab Contents -->
      <div class="tab-contents">
        <div
          class="tab-content"
          :class="{ active: true }"
          id="rank-games"
        >
          <div v-show="currentTab === 'rank-prizes'" class="box_rank your_prizes">
            <h3>{{ getTranslations.home_leaderboard_prizes }}</h3>
            <prize-selection-carousel @slide-changed="handleSlideChanged"></prize-selection-carousel>
          </div>
          <leaderboard-rank :currentPrizeType="currentTab === 'rank-games' ? 'FINAL' : currentPrizeType"></leaderboard-rank>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import PrizeSelectionCarousel from "../../common/carousel/PrizeSelectionCarousel";
import LeaderboardRank from "./LeaderboardRank";

export default {
  name: 'prizes-and-leaderboards',
  props: {
    type: {
      type: String,
    },
    userPoints: {
      type: Number,
      default: 1,
    },
    getRank: {
      type: Object,
    },
    winners: {
      type: Array,
      default: () => [],
    },
    userAvatar: {
      type: String,
    },
  },
  components: {
    LeaderboardRank,
    PrizeSelectionCarousel,
  },
  data() {
    return {
      dataReady: false, // due to network limitations we must ensure that carousel items will always be displayed correctly
      availableTypes: [],
      currentTab: 'rank-games',
      currentPrizeType: null,
    };
  },
  methods: {
    ...mapActions('profile', [
      'storePrizesAndWinners',
      'storeAvailablePrizeTypes',
    ]),
    changeTab(tab) {
      this.currentTab = tab;
    },
    handleSlideChanged(type) {
      this.currentPrizeType = type;
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'hidePrizeSectionEnabledAtLeaderBoard',
    ]),
    ...mapGetters('i18n', [
      'getLocale',
      'getTranslations'
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/prizesAndLeaderboards/PrizesAndLeaderboards.vue